/* Copyright 2013 - 2024 Waiterio LLC */
import React from 'react'

const IconLinkedin = props => {
  const { className, width = 24, height = 24, onClick, style } = props
  const title = 'icon-linkedin'
  const dataTestId = props['data-testid'] || title

  return (
    <svg
      viewBox="64 64 384 384"
      style={style}
      className={className}
      width={width}
      height={height}
      onClick={onClick}
      data-testid={dataTestId}
    >
      <title>{title}</title>
      <g>
        <path
          d="M417.2,64H96.8C79.3,64,64,76.6,64,93.9v321.1c0,17.4,15.3,32.9,32.8,32.9h320.3c17.6,0,30.8-15.6,30.8-32.9V93.9
            C448,76.6,434.7,64,417.2,64z M183,384h-55V213h55V384z M157.4,187H157c-17.6,0-29-13.1-29-29.5c0-16.7,11.7-29.5,29.7-29.5
            c18,0,29,12.7,29.4,29.5C187.1,173.9,175.7,187,157.4,187z M384,384h-55v-93.5c0-22.4-8-37.7-27.9-37.7
            c-15.2,0-24.2,10.3-28.2,20.3c-1.5,3.6-1.9,8.5-1.9,13.5V384h-55V213h55v23.8c8-11.4,20.5-27.8,49.6-27.8
            c36.1,0,63.4,23.8,63.4,75.1V384z"
        />
      </g>
    </svg>
  )
}

export default IconLinkedin
